import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import SimpleQR from './SimpleQR';

const QRModal = ({ isOpen, onClose, credencial, onGenerateImage }) => {
  if (!credencial || !credencial.id) return null;

  const getShareableUrl = () => {
    const uniqueToken = btoa(`${credencial.id}_${Date.now()}_${Math.random()}`);
    return `${window.location.origin}/#viewer/${credencial.id}?token=${uniqueToken}&t=${Date.now()}`;
  };

  const handleGenerateImage = () => {
    const canvas = document.querySelector('#qr-code-container canvas');
    if (canvas) {
      const link = document.createElement('a');
      link.download = `QR Credencial_${credencial.nombres}_${credencial.apellido_paterno}_${credencial.apellido_materno}.png`;
      link.href = canvas.toDataURL();
      link.click();
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 mb-4"
                >
                  Código QR - {credencial?.nombres}{' '}
                  {credencial?.apellido_paterno} {credencial?.apellido_materno}
                </Dialog.Title>

                <div className="flex justify-center mb-6">
                  <div
                    id="qr-code-container"
                    className="p-4 bg-white rounded-lg shadow-lg flex justify-center"
                  >
                    <SimpleQR value={getShareableUrl()} size={200} />
                  </div>
                </div>

                <div className="text-center mb-4">
                  <p className="text-sm text-gray-600">
                    Escanea este código QR para ver la credencial
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    URL segura y no rastreable
                  </p>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={handleGenerateImage}
                    className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold py-2 px-4 rounded-xl transition-all duration-300"
                  >
                    Descargar QR como imagen
                  </button>
                </div>

                <div className="mt-4">
                  <button
                    onClick={onClose}
                    className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-xl transition-all duration-300"
                  >
                    Cerrar
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default QRModal;
